export const my_listings_edit = {
  back_aria: "Back",
  page_title: "Edit listing",
  listing_status_heading: "Listing Status",
  listed_on: "Listed on {date}",
  radio_active: "Active",
  radio_sold_off: "Mark as Sold Off-Platform",
  radio_remove: "Remove from Marketplace",
  save_changes: "Save Changes",
  confirm_sold_off_title: "Confirm Off-Platform Sale",
  confirm_sold_off_body:
    "This will remove your listing from the marketplace and record that the part was sold outside PAX. Continue?",
  confirm_remove_title: "Remove Listing",
  confirm_remove_body:
    "This will remove your listing from the marketplace. Continue?",
  confirm_action: "Confirm",
  cancel: "Cancel",
  feedback_title: "How can we improve?",
  feedback_subtitle:
    "If you have a moment, tell us how we could make selling parts easier.",
  feedback_placeholder: "Write your feedback",
  feedback_skip: "Skip",
  feedback_submit: "Submit Feedback",
  feedback_close_aria: "Close",
  delist_error: "We could not update your listing. Please try again.",
};
